import React, { Component } from 'react'
import {Button, Form, Icon, Table, Image,Segment,ButtonGroup,ButtonOr,Popup} from "semantic-ui-react";
import { DropzoneComponent } from 'react-dropzone-component';
import { deleteQueryImage } from '../../data/dashboard_api';
import * as unavailable from "../../assets/photo_unavailable.jpg";

export default class EditCustomerServiceItem extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
  render() {
    let csItem = this.props.item
    

    
    
    return (
<Segment key={csItem.client_id}>
                                    
                                    <Table style={{marginBottom:"15px"}}  fixed celled compact>
                                        <Table.Body>
                                      <Table.Row>
            <Table.Cell><strong>Index & Location</strong></Table.Cell>
            <Table.Cell colSpan={4}> 
            <Button primary compact basic size="mini" onClick={(e)=>{e.preventDefault()}}><Icon name="hashtag"></Icon>{csItem.item_index}</Button>
            <Button onClick={(e)=>{e.preventDefault()}} compact basic color="green" size="mini">{csItem.room}</Button>
            <Button onClick={(e)=>{e.preventDefault()}} compact basic color="orange" size="mini">{csItem.group}</Button></Table.Cell>
        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>Item Description</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.name}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>CI Notes</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.ci_notes || "None"}</Table.Cell>
                                        </Table.Row>
                                       {this.props.inspection_type == "co" && <Table.Row>
                                            <Table.Cell><strong>CO Notes</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.co_notes || "None"}
                                            {csItem.flag && <Button onClick={e =>{e.preventDefault()}}compact size="mini" basic color="orange">{csItem.flag}</Button>}
            {csItem.additional_notes.length > 0 ?<Popup trigger={<Button icon="list" labelPosition='left' compact size="mini" content={"Additional Notes"} basic onClick={e =>{e.preventDefault()}} color="grey"/>}>
                <ul>{csItem.additional_notes.map((note) =>{return <li>{note.co_notes} {note.flag && <Button onClick={e =>{e.preventDefault()}}compact size="mini" basic color="orange">{note.flag}</Button>} </li>})}</ul>
            </Popup>:null}</Table.Cell>
                                        </Table.Row>}
                                        <Table.Row>
                                            <Table.Cell><strong>Item Query Comment</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.comments}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>Show in PDF</strong></Table.Cell>
                                        <Table.Cell colSpan={4}>            
                                        {<ButtonGroup>
                                            <Button positive={csItem.visible} onClick={(e)=>{e.preventDefault(); this.props.updateCSItemVisibility(this.props.indexNo,true)} }>Visible</Button>
                                            <ButtonOr />
                                            <Button negative={!csItem.visible} onClick={(e)=>{e.preventDefault(); this.props.updateCSItemVisibility(this.props.indexNo,false)} }>Not Visible</Button>
                                            </ButtonGroup>}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>Clerk Comment</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>
                                            <Form.TextArea 
                                        defaultValue={csItem.clerk_comments}
                                        style={{ minHeight: 180 }}
                                                           onChange={(e) => {
                                                             this.props.updateCSItem(this.props.indexNo,e.target.value)
                                        }} />
                                            </Table.Cell>
                                        </Table.Row>
                                        </Table.Body>
                                        </Table>
                                <Image.Group size="small">
                                {csItem.customer_service_item_images && csItem.customer_service_item_images.map((image) => {
                                    return (image.image_path && <Image key={image.id}
                                        style={{ cursor: "pointer" }}
                                        className="grow"
                                        rounded
                                        src={image.image_path}
                                        target="_blank"
                                    />)
                                })}
                      </Image.Group>
                      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/inspection/edit_query_item.js